import ProductTicket from './ProductTicket';
import { ProductTicketRouletteResponse } from '../types';

class ProductTicketRoulette extends ProductTicket {
  ticket: ProductTicketRouletteResponse;

  constructor(ticket: ProductTicketRouletteResponse) {
    super(ticket);
    this.ticket = ticket;
  }

  getBetshopUuid() {
    return this.ticket.paymentBetshopId;
  }
}

export default ProductTicketRoulette;
